import React, { FC } from 'react'
import styles from '../../styles'
import { Card, Grid, styled } from '@mui/material'
import ErrorIcon from '@mui/icons-material/Error'

const ErrorCardContainer = styled(Grid)(() => ({
	justifyContent: 'center',
	alignItems: 'center',
	backgroundColor: '#e34843'
}))

const ErrorCardMessage = styled(Grid)(({ theme }) => ({
	padding: 12,
	whiteSpace: 'break-spaces',
	...styles(theme).colorBlue,
	...styles(theme).text3
}))

interface AcceptingProps {
	message: string
}

type ErrorCardProps = AcceptingProps

const ErrorCard: FC<ErrorCardProps> = ({ message }) => {
	return (
		<Card variant="outlined">
			<Grid container item>
				<ErrorCardContainer container item xs={2}> <ErrorIcon style={{ color: 'white' }} /> </ErrorCardContainer>
				<ErrorCardMessage container item xs={10}>{message}</ErrorCardMessage>
			</Grid>
		</Card>
	)
}

export default ErrorCard